<template>
<div class="wrapper">
  <router-view/>
</div>
</template>

<script>
import '@/bootstrap.js'
export default {
  name: 'App',
}
</script>

<style>
html, body {
  height: 100%;
  margin: 0;
  background-image: url('assets/background.jpg');
  background-repeat: no-repeat;
  background-position: center;
  background-size:cover;
  box-shadow: ivory;
}
font-awesome-icon{
  display: block;
  float: left;
}
#rns{
  display: block;
  margin: auto;
}
#app {
  margin: 5%;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue